<template lang="html">
    <v-form v-model="isValid" ref="form" @submit.prevent=''>
        <v-container grid-list-xs>
            <v-layout wrap>

                <v-flex xs12>
                    <v-text-field label="Nom" v-model="model.label" :rules="rules.label" required></v-text-field>
                </v-flex>
                <v-flex xs12>
                    <v-select
                        label="Fournisseur"
                        autocomplete
                        required
                        chips
                        clearable
                        ref="select"
                        :items="suppliers"
                        item-text="name"
                        item-value="id"
                        :rules="rules.supplier_id"
                        v-model="model.supplier_id"
                        @keyup.enter.native="addTag($event)"
                        @keydown.tab.native="tab"
                        >

                        <template slot="selection" slot-scope="data">
                            <v-chip>
                                {{ data.item.name }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data">
                            <template v-if="typeof data.item === 'object'">
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                        <template slot="no-data">
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>Appuyer sur Entrer pour ajouter</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                    </v-select>
                </v-flex>
                <v-flex xs12>
                    <v-text-field label="Lien externe" v-model="model.external_link" ref="link"></v-text-field>
                </v-flex>
            </v-layout>
        </v-container>
    </v-form>
</template>

<script>

export default {
	props: {
		params: {
			required: true
		}
	},
	data() {
		return {
			title: 'Ajouter un produit',
			icon: 'build',
			parent_category: null,
			isValid: false,
            disableEnter: true,

			model: {
				photo: '',
				label: '',
				type: '',
				category_id: '',
				supplier_id: '',
				group: '',
				project_id: '',
                external_link: '',
                user_id: ''
			},
			categories: [],
			suppliers: [],
            keep_selected_supplier:[],

			rules: {
				label: [
					(v) => !!v || 'Nom obligatoire',
				],
				supplier_id: [
					(v) => !!v || 'Fournisseur obligatoire',
				]
			}
		}
	},
	mounted() {
		this.axios.get('/api/categories?filters=type|=|Super_family&embed=children.children')
			.then(response => {
				this.categories = [];
				let i, j, category, child;
				for (i = 0; i < response.data.length; i++) {
					category = response.data[i];
					this.categories.push({ header: category.label })
					for (j = 0; j < category.children.length; j++) {
						child = category.children[j];
						this.categories.push({ label: child.label, id: child.id, group: 'category.label', children: child.children });
					}
					this.categories.push({ divider: true });
				}
			})
			.catch(err => console.log(error))

		this.axios.get('/api/suppliers')
			.then(response => {
				this.suppliers = [];
				let i, supplier;
				for (i = 0; i < response.data.length; i++) {
					supplier = response.data[i];
					this.suppliers.push({ name: supplier.name, id: supplier.id });
				}
			})
			.catch(err => console.log(error))

	},
    watch:{
        'model.supplier_id'(val){
            if(val){
                this.keep_selected_supplier = val
            }
        }
    },

	methods: {
		onClose() {
			this.$eventHub.$emit('close-modal')
		},

		onValidate() {
			this.model.type = this.params.type
			this.model.project_id = this.$route.params.id
            this.model.user_id = this.$store.state.auth.user.id
            this.model.category_id = this.$store.state.single.data.category_id
            this.model.group = this.$store.state.single.data.group

			if (this.$refs.form.validate()) {
				this.axios.post('/api/products', this.model)
					.then(response => {
						this.$eventHub.$emit('close-modal');
						if(response.status === 200 || response.status === 201) {
                            this.$eventHub.$emit('reload-single-project');
                        }
					})
					.catch(err => console.log(err))
			} else {
				return false;
			}
		},
        addTag(val){
            if(this.suppliers.filter(s => s.name == val.target.value).length == 0){
                this.axios.post(`/api/suppliers`, {name:val.target.value})
                .then(response => {
                    this.suppliers.push(response.data)
                    this.model.supplier_id = response.data.id
                    if(this.$refs.select) {
                        this.$refs.select.searchValue = null
                    }
                })
            }
        },
        tab(){
            setTimeout(() => {
                this.model.supplier_id = this.keep_selected_supplier
                this.$refs.link.focus()
            },0.05)
        }
	},
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/projects/single/CreateProduct.vue